import { useState, useEffect } from 'react';
import { Loader } from '@googlemaps/js-api-loader';

const useGoogleMaps = () => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [loadError, setLoadError] = useState(null);

  useEffect(() => {
    const initializeGoogleMaps = async () => {
      const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

      if (!apiKey) {
        setLoadError('Google Maps API key not found. Please add REACT_APP_GOOGLE_MAPS_API_KEY to your .env.local file');
        return;
      }

      try {
        const loader = new Loader({
          apiKey: apiKey,
          version: '3.64',
          libraries: ['places', 'geometry', 'drawing', 'visualization'],
        });

        await loader.load();

        // Verify that the drawing library is loaded
        if (window.google?.maps?.drawing) {
          console.log('✅ Google Maps with Drawing library loaded successfully');
          setIsLoaded(true);
        } else {
          console.error('❌ Drawing library not available');
          setLoadError('Drawing library failed to load. Please check your Google Maps API configuration.');
        }
      } catch (error) {
        console.error('❌ Error loading Google Maps:', error);
        setLoadError(`Failed to load Google Maps: ${error.message}`);
      }
    };

    initializeGoogleMaps();
  }, []);

  return { isLoaded, loadError };
};

export default useGoogleMaps;